import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import selectors from './selectors';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPIActions from '../../utils/api-metadata-actions';
import moment from 'moment';

export const options = {
  name: 'incidents',
  baseType: 'INCIDENTS',
  apiEndpoint: 'incidents',
  transform: incident => ({
    ...incident,
    // replace actual responses with reference to id, because we're going to
    // store responses in a separate reducer
    responseIds: incident.incident_responses.map(r => r.id)
  }),
  createNew: () => ({
    body: '',
    description: '',
    start_time: moment().startOf('minute').format(),
    end_time: moment().add(2, 'hours').startOf('minute').format(),
    activity_type_ids: [],
    prio: null,
    type: 'incident_report',
    external_id: '',
    manual: true
  })
};

const operations = createMetadataAPIOperations(options);
const actions = createMetadataAPIActions(options);

export { operations, selectors, actions };
export default createMetadataAPIReducer(options);
